import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { PuroStatsInput } from '@libs/types/src/services/input-type/statistics/puro-stats.input';
import { puroClientsFrag, puroHighCostClientsFrag } from './types/puro.gql-types';
import {
    PuroBonifiedClients,
    PuroGridObject,
    PuroHighCostClientsGridObject,
    PuroStatsObject,
    PuroUnlimitedPayments,
} from '@libs/types/src/services/object-type/statistics/puro-stats.object';
import { filterFrag } from '../modules/content/service/types/filter.types';
import { GridInput } from '@it2go/data-grid';

@Injectable({ providedIn: 'root' })
export class PuroGqlService extends GqlServiceV2 {

    public async getPuroStatistics(input: PuroStatsInput, fragment: string) {
        return this.query<PuroStatsObject[]>(
            `
                query($input: PuroStatsInput!) {
                    puro {
                        puroStats(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getPuroHighCostClients(input: GridInput, fragment: string = puroHighCostClientsFrag) {
        return this.query<PuroHighCostClientsGridObject>(
            `
                query($input: GridInput!) {
                    puro {
                        highCostClients(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getPuroHighCostCandidates(input: GridInput, fragment: string = puroHighCostClientsFrag) {
        return this.query<PuroHighCostClientsGridObject>(
            `
                query($input: GridInput!) {
                    puro {
                        highCostCandidates(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getPuroBonifiedClients(input: PuroStatsInput, fragment: string) {
        return this.query<PuroBonifiedClients>(
            `
                query($input: PuroStatsInput!) {
                    puro {
                        bonifiedClients(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getPuroClients(input: GridInput, fragment: string = puroClientsFrag) {
        return this.query<PuroGridObject>(
            `
                query($input: GridInput!) {
                    puro {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getPuroUnlimitedPayments(input: PuroStatsInput, fragment: string) {
        return this.query<PuroUnlimitedPayments>(
            `
                query($input: PuroStatsInput!) {
                    puro {
                        unlimitedPayments(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
